import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { HANDLE_HTTP_ERROR_LOCALLY } from '../../../../http/http-context-tokens';
import { BuscaGlobalApi, BuscaGlobalFiltro } from '../../../../dtos/sai/core/busca-global';
import { ResponseApi } from '../../../../dtos/response-api';
import { buildHttpParams } from '../../../../../shared/utils/http-params.util';

/** Registros da busca global do topo, no escopo do usuário (change busca-global-api). */
@Injectable({
  providedIn: 'root'
})
export class BuscaGlobalApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/sai/core/BuscaGlobal`;

  /** O erro fica com quem chama: a barra cai em "só telas", sem alerta. */
  buscar(filtro: BuscaGlobalFiltro): Observable<ResponseApi<BuscaGlobalApi>> {
    return this.http.get<ResponseApi<BuscaGlobalApi>>(this.baseUrl, {
      params: buildHttpParams(filtro),
      context: new HttpContext().set(HANDLE_HTTP_ERROR_LOCALLY, true)
    });
  }
}
